import router from '@/router'
// eslint-disable-next-line object-curly-newline
import { reactive, getCurrentInstance, watch, toRefs } from '@vue/composition-api'

export const isObject = obj => typeof obj === 'object' && obj !== null

export const isToday = date => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

const getRandomFromArray = array => array[Math.floor(Math.random() * array.length)]

// ? Light and Dark variant is not included
// prettier-ignore
export const getRandomBsVariant = () => getRandomFromArray(['primary', 'secondary', 'success', 'warning', 'danger', 'info'])

export const isDynamicRouteActive = route => {
  const { route: resolvedRoute } = router.resolve(route)
  return resolvedRoute.path === router.currentRoute.path
}

// Thanks: https://medium.com/better-programming/reactive-vue-routes-with-the-composition-api-18c1abd878d1
export const useRouter = () => {
  const vm = getCurrentInstance().proxy
  const state = reactive({
    route: vm.$route,
  })

  watch(
    () => vm.$route,
    r => {
      state.route = r
    },
  )

  return { ...toRefs(state), router: vm.$router }
}

/**
 * This is just enhancement over Object.extend [Gives deep extend]
 * @param {target} a Object which contains values to be overridden
 * @param {source} b Object which contains values to override
 */
// export const objectExtend = (a, b) => {
//   // Don't touch 'null' or 'undefined' objects.
//   if (a == null || b == null) {
//     return a
//   }

//   Object.keys(b).forEach(key => {
//     if (Object.prototype.toString.call(b[key]) === '[object Object]') {
//       if (Object.prototype.toString.call(a[key]) !== '[object Object]') {
//         // eslint-disable-next-line no-param-reassign
//         a[key] = b[key]
//       } else {
//         // eslint-disable-next-line no-param-reassign
//         a[key] = objectExtend(a[key], b[key])
//       }
//     } else {
//       // eslint-disable-next-line no-param-reassign
//       a[key] = b[key]
//     }
//   })

//   return a
// }


// ******************************************************************************************************
// import data from './data.js'
// currency
export const GetLinkCurrency = (currency) => {
  if (currency) {
    return currency
  } else {
    return "TND"
  }
};

export const GetObjCurrency = (value) => {
  // if (this.$store.user.) return new Date(value).toLocaleString();
  // else return "Pas de devise"
  return "TND"
};

// price
export const getPercentage = (num, per) => {
  if (num != 0 && per != 0)
    return ((Number.parseFloat(num) / 100) * Number.parseFloat(per));
}

export const add = (a,b) => {
  if (a && b)
    return (Number.parseFloat(a) + Number.parseFloat(b)) ;
}

export const mult = (a, b) => {
  if (a && b)
    return (Number.parseFloat(a) * Number.parseFloat(b));
}


export const getPriceProduct = (value) => {
  console.log('value get price',value)
  var NewResult = {
    tax: 0,
    priceWithTax: 0,
    discount: 0
  }
  if (!value.quantity) {
    value.quantity = 1;
  }
  if (value.tax && value.tax!=0) {
    NewResult.tax = getPercentage(value.price, value.tax) * Number.parseFloat(value.quantity)
  } 
  if (value.quantity && value.quantity != 0) {
    NewResult.priceWithTax = (Number.parseFloat(value.price) * Number.parseFloat(value.quantity)) + NewResult.tax
  }
  if (value.discount && value.discount != 0 && value.quantity) {
    NewResult.discount = getPercentage(NewResult.priceWithTax, Number.parseFloat(value.discount))
  }
  return NewResult
};


export const getTotalResult = (values) => {
  console.log("values",values);
  var NewResult = {
    priceWithoutTaxes: 0,
    valueAddedTax: 0,
    valueDiscount: 0,
    allTaxesIncluded: 0,
    allTaxesIncludedWithDiscount: 0
  }
  if (values) {
    values.forEach(element => {
      NewResult.valueAddedTax += Number.parseFloat(element.valueTax)
      NewResult.valueDiscount += Number.parseFloat(element.valueDiscount)
      NewResult.allTaxesIncluded += Number.parseFloat(element.allTaxesIncluded)
      NewResult.priceWithoutTaxes += Number.parseFloat(element.price) * Number.parseFloat(element.quantity)
      NewResult.allTaxesIncludedWithDiscount += Number.parseFloat(element.allTaxesIncludedWithDiscount)
   });
  }
  return NewResult
}
